import { render, staticRenderFns } from "./TableCampaignApplicants.vue?vue&type=template&id=45878f78&scoped=true"
import script from "./TableCampaignApplicants.vue?vue&type=script&lang=js"
export * from "./TableCampaignApplicants.vue?vue&type=script&lang=js"
import style0 from "./TableCampaignApplicants.vue?vue&type=style&index=0&id=45878f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45878f78",
  null
  
)

export default component.exports